const trimTrailingSlashes = (value) => value.replace(/\/+$/, '');

export const imageStorageUrl = process.env.REACT_APP_R2_PUBLIC_URL
  ? trimTrailingSlashes(process.env.REACT_APP_R2_PUBLIC_URL)
  : '';

export const getStoryImageUrl = (imageNo) =>
  `${imageStorageUrl}/ChainMail-ekezia-${imageNo}.jpg`;
